import gql from 'graphql-tag';

const MEMBER_LICENSE_DOWNLOAD = gql`
query memberLicenseDownload($ids: [ID!]!) {
  memberLicenseDownload(ids: $ids) {
    type
    url
    expiresAt
  }
}
`;

export default MEMBER_LICENSE_DOWNLOAD;